/**
 * Customer-site registry — slug → static config + template.
 *
 * In production, the source of truth is the backend `customer_websites`
 * collection (fetched via /api/website-config/by-slug/{slug}). This file
 * is the offline/parity copy used to:
 *   1. render correctly even before the backend response arrives
 *   2. provide local content (services, FAQ, gallery, copy) the backend
 *      doesn't currently store — until the Website Builder admin UI ships
 *
 * Future Website Builder add-on will:
 *   - allow user to pick template (1 of 20)
 *   - allow user to edit content fields directly
 *   - replace this static map with DB-driven configs
 */
import evolveDrywallConfig from './customerSites/evolvedrywall';
import topflightConfig from './customerSites/topflight';

export const SITE_REGISTRY = {
  evolvedrywall: evolveDrywallConfig,
  topflight: topflightConfig,
};

export function getSiteBySlug(slug) {
  if (!slug) return null;
  return SITE_REGISTRY[String(slug).toLowerCase()] || null;
}

export function getSiteByDomain(host) {
  if (!host) return null;
  const h = host.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '');
  const bare = h.startsWith('www.') ? h.slice(4) : h;
  for (const cfg of Object.values(SITE_REGISTRY)) {
    if (!cfg?.custom_domain) continue;
    const cd = cfg.custom_domain.toLowerCase();
    const cdBare = cd.startsWith('www.') ? cd.slice(4) : cd;
    if (cd === h || cdBare === bare) return cfg;
  }
  return null;
}

export default SITE_REGISTRY;
